<template>
  <div class="box">
    <div class="left">
      <div class="left-t">
        <el-form :model="formData" class="demo-form-inline">
          <el-form-item>
            <el-input
              v-model="formData.user"
              placeholder="请输入联系人名称搜索"
            >
            <el-button slot="append" icon="el-icon-search"  @click="onSearch"></el-button>

          </el-input>
          </el-form-item>
        
        </el-form>
      </div>
      <div class="left-b">
        <ul>
            <user-item
              v-for="(item, index) in friendList"
              @selectItem="selectFriend"
              :key="index"
              :index="index"
              :avatar="item.user_avatar"
              :name="item.friend_user_name"
              :time="item.updated_at"
              :content="item.message"
              :active="chatIndex==index"
              :unread="item.unread_num"

            >
            </user-item>
        </ul>
      </div>
    </div>
    <div class="right" v-if="friendInfo">
      <div class="right-t">
        <img :src="friendInfo.user_avatar" alt="" />
        <aside>
          <img v-if="friendInfo.sex==2" src="~@/assets/chat-img/sexwman.png" alt="" />
          <img  v-if="friendInfo.sex==1" src="~@/assets/chat-img/sexman.png" alt="" /> 
        </aside>
      </div>
      <div class="right-m">
        <p> {{ friendInfo.friend_user_name }}</p>
        <section>
          <span @click="bz">备注：</span>
          <div>
            <p  @click="bz" class="first" v-if="setRemark==false">
              {{ friendInfo.friend_remarks }}
            </p>
            <input v-if="setRemark" type="text" v-model="userRemark"  @blur="setUserRemark" />
          </div>
        </section>
      </div>
      <div class="right-b">
        <el-button type="primary" @click="sendMsg">发消息</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { chatList,messagelist,userfriendList,updateFriend} from "@/api/chat/index";
import { mapGetters } from 'vuex'
import userItem from "@/components/chat/user-item.vue";

export default {
  components: {
    userItem
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },
  data() {
    return {
      chatIndex:-1,
      friendInfo: null,
      friendList:[],
      setRemark:false,
      userRemark:"",

      formData: {
        user: "",
      },
    };
  },
  mounted(){
    this.fetchFriendList();
    
  },

  methods: {
    onSearch(){
      this.fetchFriendList();

    },

    fetchFriendList(){
      var that = this;
      var params={
       
      }

      userfriendList(params).then((response) => {
        that.friendList= response.data;
      });
    },

    selectFriend(index){
      this.chatIndex=index;
      this.friendList[index].active=true;
      this.friendInfo= this.friendList[index];
      console.log("frindInfo",this.friendInfo);

    },

    //设置备注
    bz() {
      this.setRemark=true;
     
    },
    setUserRemark() {
      if(this.userRemark==""){
        this.$message.warning("备注不能为空");

        return;
      }
      var params={
        friend_remarks:this.userRemark,
        friend_user_app_id:this.friendInfo.friend_user_app_id
      }
      
      updateFriend(params).then((response) => {
        if(response.code==200){
          this.$message.success("修改成功");
          this.friendInfo.friend_remarks=this.userRemark
          this.setRemark=false;
        }else{
          this.$message.error(response.msg?response.msg:"修改失败");
        }
       
      });
    },

    sendMsg(){
      ////好友列表去聊呗是1，客服列表去聊呗是3，其余的全是2
      this.ws.initWebSocket(this.wsUrl+"?send_user_id="+this.userInfo.user_app_id+"&receive_user_id="+this.friendInfo.friend_user_app_id+"&link=1");

      this.$router.push({ name: "director-chat-info" });


    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  height: 648px;
}

.left {
  width: 316px;
}

.right {
  width: 884px;
  background-color: #fbfbfb;
}

.left-t {
  height: 29px;
  margin-top: 29px;
  margin-left: 13px;
  margin-bottom: 11px;
}

.left-b ul {
  height: 576px;
  // background-color: red;
  overflow: scroll;
}

.left-b ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 1px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .right-t {
    position: relative;

    img {
      width: 130px;
      height: 130px;
      border-radius: 50%;
    }

    aside {
      position: absolute;
      top: 95px;
      left: 96px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .right-m {
    width: 200px;
    text-align: center;
    height: 80px;
    position: relative;

    section {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      font-size: 19px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;

      span {
        font-size: 11px;
        font-weight: 400;
        color: #999999;
      }

      .first {
        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }

      input {
        width: 100px;
        border: 0;
        outline: 0;
      }
    }
  }

  
}
</style>
